var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Collapse } from '../collapse';
import { ChevronDownIcon, ChevronUpIcon } from '../icon';
import { IconButton } from '../icon-button';
import { fade } from '../styles/color-manipulator';
import { styled } from '../styled';
import { TableCell, TableRow } from '../table';
import { Box } from '../box';
var Row = styled(TableRow, { name: 'QuantumDataTableRow', slot: 'row' })(function (_a) {
    var ownerState = _a.ownerState, theme = _a.theme;
    return (__assign(__assign({}, (ownerState.expandable && {
        '& > *': {
            borderBottom: 'none',
        },
    })), (ownerState.expanded && {
        backgroundColor: fade(theme.tokens.color_bg_interactive_hover, 0.5),
    })));
});
export var isRenderableColumn = function (column) {
    return !!column.render;
};
export function DataTableRow(props) {
    var _a = __read(React.useState(false), 2), isExpanded = _a[0], setIsExpanded = _a[1];
    var item = props.item, index = props.index, columns = props.columns, onRowClick = props.onRowClick, renderItemDetails = props.renderItemDetails, componentRenderer = props.componentRenderer, hover = props.hover, hideHeader = props.hideHeader, rowProps = __rest(props, ["item", "index", "columns", "onRowClick", "renderItemDetails", "componentRenderer", "hover", "hideHeader"]);
    var detailsContent = null;
    if (renderItemDetails) {
        detailsContent = renderItemDetails(item);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, __assign({}, { component: componentRenderer ? componentRenderer(item, index) : 'tr' }, { hover: hover, ownerState: { expandable: !!detailsContent, expanded: isExpanded } }, rowProps),
            columns.map(function (column, colIndex) {
                if (!column) {
                    return null;
                }
                var content = null;
                if (isRenderableColumn(column)) {
                    content = column.render({ item: item, index: index });
                }
                else {
                    content = item[column.field] || null;
                }
                return hideHeader ? (React.createElement(TableCell, { width: column.width, key: colIndex, align: column.align, padding: column.padding }, content)) : (React.createElement(TableCell, { key: colIndex, align: column.align, padding: column.padding }, content));
            }),
            !!renderItemDetails && (React.createElement(TableCell, { padding: "checkbox", align: "right" }, !!detailsContent && (React.createElement(IconButton, { onClick: function () { return setIsExpanded(!isExpanded); }, variant: "link" }, isExpanded ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null)))))),
        !!detailsContent && (React.createElement(Row, { ownerState: { expanded: true } },
            React.createElement(TableCell, { padding: "none", colSpan: columns.length + 1 },
                React.createElement(Collapse, { in: isExpanded, timeout: "auto", unmountOnExit: true },
                    React.createElement(Box, { p: 2 }, detailsContent)))))));
}
